<template>
  <div class="mt-3">
    <div class="card border pt-2 pb-0 px-2 col-12 bg-revenue">
      <BOverlay
        :show="isLoadingRevenue"
        spinner-variant="primary"
        variant="light"
        blur="0.1"
        opacity="0.5"
        rounded="sm"
      >
        <div class="d-flex justify-content-between flex-md-row flex-column-reverse">
          <div class="d-flex flex-column justify-content-start">
            <div class="d-flex gap-2 align-items-center">
              <div class="bg-[#BEE6FC] p-[3px] rounded">
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/usd-coin-blue.svg"
                  alt="revenue"
                  width="20px"
                >
              </div>
              <span class="text-[16px] text-[#626262]">Total Revenue</span>
            </div>
            <div class="d-flex align-items-center gap-1">
              <span class="text-black text-[38px] font-[600]">{{ IDR(dataAnalyticRevenue.total || 0) }}</span>
              <span
                v-if="dataAnalyticRevenue.percentage !== 0"
                :class="badgeClass"
                class="px-[10px] py-[4px] rounded rounded-pill"
              >{{ dataAnalyticRevenue.percentage || 0 }}%</span>
            </div>
            <span class="text-[#626262] mt-2">Last month revenue : {{ IDR(dataAnalyticRevenue.last_month || 0) }}</span>
          </div>
          <div
            class="d-flex justify-content-end col-6 p-0"
            style="height: 37px;"
          >
            <BButton
              id="periodeRevenue"
              variant="outline-secondary"
              class="!h-[37px] w-[150px] text-left d-flex justify-content-between align-items-center bg-white"
              @click="popoverShowRevenue = !popoverShowRevenue"
            >
              <span class="text-nowrap truncate">{{ lableButtonRevenue }}</span>
              <img
                :src="popoverShowRevenue ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-up-2.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg'"
                alt="arrow"
                width="15px"
              >
            </BButton>
            <BPopover
              id="periode-list"
              target="periodeRevenue"
              placement="bottom"
              triggers="manual"
              :show.sync="popoverShowRevenue"
            >
              <ul style="margin: -8px -10px -8px -10px;">
                <li
                  v-for="(value, idx) in optionsDate"
                  :key="idx"
                >
                  <BButton
                    class="w-100 text-left"
                    variant="light"
                    @click="onRevenueFilterSelect(value.value)"
                  >
                    {{ value.text }}
                  </BButton>
                </li>
                <li>
                  <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    :locale-data="locale"
                    :ranges="ranges"
                    :opens="'left'"
                    control-container-class="border-0"
                    class="w-100"
                    @update="onRevenueFilterSelect('custom')"
                  >
                    <template v-slot:input="picker">
                      <BButton
                        class="w-100 text-left"
                        variant="light"
                      >
                        Date Picker
                      </BButton>
                      <span class="d-none">{{ picker }}</span>
                    </template>
                  </date-range-picker>
                </li>
              </ul>
            </BPopover>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-2 gap-1 flex-column flex-lg-row">
          <RevenueCard
            title="Subs Revenue"
            :data="dataSubsRevenue"
          />
          <RevenueCard
            title="Shipping Earnings"
            :data="dataShippingEarnings"
          />
          <RevenueCard
            title="Payment Service Revenue"
            :data="dataPaymentServiceRevenue"
          />
          <RevenueCard
            title="QRISLY Revenue"
            :data="dataQrislyRevenue"
          />
        </div>
      </BOverlay>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
      <div class="card border rounded py-2 px-2 col">
        <BOverlay
          :show="loadingSubscription"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity="0.7"
          rounded="sm"
        >
          <div class="d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-start gap-2 align-items-center">
                <div
                  class="p-[3px] rounded bg-[#D6EEDD]"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/icons/usd-coin-blue.svg"
                    alt="revenue"
                    width="20px"
                  >
                </div>
                <span class="text-[16px] text-[#626262]">User Subscription</span>
              </div>
              <div
                class="d-flex justify-content-end col-6 p-0"
                style="height: 37px;"
              >
                <BButton
                  id="periode"
                  variant="outline-secondary"
                  class="!h-[37px] w-[150px] text-left d-flex justify-content-between align-items-center"
                  @click="popoverShow = !popoverShow"
                >
                  <span class="text-nowrap truncate">{{ lableButton }}</span>
                  <img
                    :src="popoverShow ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-up-2.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg'"
                    alt="arrow"
                    width="15px"
                  >
                </BButton>
                <BPopover
                  id="periode-list-subs"
                  target="periode"
                  placement="bottom"
                  triggers="click"
                  :show.sync="popoverShow"
                >
                  <ul style="margin: -8px -10px -8px -10px;">
                    <li
                      v-for="(value, idx) in optionsDate"
                      :key="idx"
                    >
                      <BButton
                        class="w-100 text-left"
                        variant="light"
                        @click="getDataAnalytic('user_subscription', value.value); popoverShow = false; loadingSubscription = true;"
                      >
                        {{ value.text }}
                      </BButton>
                    </li>
                    <li>
                      <date-range-picker
                        ref="picker"
                        v-model="dateRange"
                        :locale-data="locale"
                        :ranges="ranges"
                        :opens="'left'"
                        control-container-class="border-0"
                        class="w-100"
                        @update="getDataAnalytic('user_subscription', 'custom')"
                      >
                        <template v-slot:input="picker">
                          <BButton
                            class="w-100 text-left"
                            variant="light"
                          >
                            Date Picker
                          </BButton>
                          <span class="d-none">{{ picker }}</span>
                        </template>
                      </date-range-picker>
                    </li>
                  </ul>
                </BPopover>
              </div>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span class="text-black text-[24px] font-semibold">{{ dataSubscription.total || 0 }}</span>
              <span
                :class="dataSubscription.percentage < 0 ? 'decreased-second ' : 'increased-second'"
                class="text-[12px] px-[10px] py-[4px] rounded rounded-pill text-nowrap"
              >{{ dataSubscription && dataSubscription.percentage != null ? parseFloat(dataSubscription.percentage.toFixed(2)) : 0 }}%</span>
            </div>
          </div>
          <Apexcharts
            ref="myChart"
            height="100"
            type="bar"
            class="mt-[-20px] ml-[-24px]"
            :options="chartOptions"
            :series="chartOptions.series"
          />
        </BOverlay>
      </div>
      <div class="d-flex flex-column flex-lg-row gap-1">
        <CardAnalytic
          v-for="(item, index) in analytics.slice(0, 2)"
          :key="index"
          v-bind="item"
          :options-date="optionsDate"
          :loading="getLoadForValue(item.value)"
          :data-analytic="getDataForValue(item.value)"
          :is-all-time="true"
          :index="index"
          @getDataAnalytic="getDataAnalytic"
        />
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-1">
      <CardAnalytic
        v-for="(item, index) in analytics.slice(2, 8)"
        :key="index"
        v-bind="item"
        :options-date="optionsDate.slice(1)"
        :loading="getLoadForValue(item.value)"
        :data-analytic="getDataForValue(item.value)"
        :is-all-time="false"
        :index="index"
        @getDataAnalytic="getDataAnalytic"
      />
    </div>
  </div>
</template>

<script>
import {
  BPopover,
} from 'bootstrap-vue'
import { LABELDAY, LABELMONTH, YEAR_MONTH_DAY } from '@/libs/filterDate'
import moment from 'moment'
import {
  today,
  last7,
  last2,
  last30,
  firstDateOfMonth,
  lastDateOfMonth,
  lastMonth,
  lastDateOfLastMonth,
} from '@/store/helpers'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { collaboratorAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import Apexcharts from 'vue-apexcharts'
import CardAnalytic from '../components/CardAnalytic.vue'
import RevenueCard from '../components/RevenueCard.vue'
import { chartOptions, analytics } from '../config'

const REVENUE_TYPES = ['revenue', 'subscription_revenue', 'shipping_earning']
const DATE_RANGE_TYPES = ['user_subscription', ...REVENUE_TYPES]

const LOADING_MAP = {
  revenue: 'isLoadingRevenue',
  subscription_revenue: 'isLoadingRevenue',
  shipping_earning: 'isLoadingRevenue',
  user_subscription: 'loadingSubscription',
  registered_user: 'isLoadingReg',
  verified_user: 'isLoadingVerif',
  request_pickup: 'isLoadingPickup',
  user_starter: 'isLoadingStarter',
  user_pro: 'isLoadingPro',
  user_enterprise: 'isLoadingEnterprise',
  order_problem: 'isLoadingProblem',
  order_received: 'isLoadingDelivered',
  retention_user: 'isLoadingRetention',
  total_order: 'isLoadingOrder',
  user_active: 'isLoadingActive',
}

const DATA_MAP = {
  revenue: 'dataAnalyticRevenue',
  registered_user: 'dataRegister',
  verified_user: 'dataVerify',
  request_pickup: 'dataPickup',
  user_subscription: 'dataSubscription',
  subscription_revenue: 'dataSubsRevenue',
  shipping_earning: 'dataShippingEarnings',
  order_received: 'dataDelivered',
  order_problem: 'dataProblem',
  user_active: 'dataActive',
  retention_user: 'dataRetention',
  total_order: 'dataOrder',
}

export default {
  components: {
    CardAnalytic, RevenueCard, Apexcharts, BPopover, DateRangePicker,
  },
  data() {
    return {
      IDR,
      YEAR_MONTH_DAY,
      picker: {
        startDate: firstDateOfMonth,
        endDate: lastDateOfMonth,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'This Month': [firstDateOfMonth, today],
        'Last 30 Days': [last30, today],
        'Last Month': [lastMonth(1), lastDateOfLastMonth],
        'Last 2 Months': [lastMonth(2), lastDateOfLastMonth],
        'Custom Range': [today, today],
      },
      today,
      last7,
      last2,
      last30,
      firstDateOfMonth,
      lastDateOfMonth,
      dateRange: {
        startDate: last30,
        endDate: today,
      },
      isLoadingRevenue: false,
      isLoadingReg: false,
      isLoadingVerif: false,
      isLoadingPickup: false,
      isLoadingRetention: false,
      isLoadingOrder: false,
      isLoadingProblem: false,
      isLoadingDelivered: false,
      isLoadingActive: false,
      loadingSubscription: false,
      dateRevenue: 'this_month',
      optionsDate: [
        { text: 'All Time', value: 'all_time' },
        { text: 'This Month', value: 'this_month' },
        { text: 'Previous Month', value: 'last_month' },
        { text: 'This Week', value: 'this_week' },
        { text: 'Last Week', value: 'last_week' },
      ],
      analytics,
      dataAnalyticRevenue: {},
      dataRegister: {},
      dataVerify: {},
      dataPickup: {},
      dataRetention: {},
      dataOrder: {},
      dataProblem: {},
      dataDelivered: {},
      dataActive: {},
      dataSubscription: {},
      dataSubsRevenue: {},
      dataShippingEarnings: {},
      dataPaymentServiceRevenue: {},
      dataQrislyRevenue: {},
      chartOptions,
      popoverShow: false,
      popoverShowRevenue: false,
      lableButton: 'All Time',
      lableButtonRevenue: 'This Month',
    }
  },
  computed: {
    badgeClass() {
      return this.dataAnalyticRevenue.percentage > 0 ? 'increased-revenue' : 'decreased'
    },
  },
  mounted() {
    this.getDataAnalytic('revenue', 'this_month')
    this.getDataAnalytic('subscription_revenue', 'this_month')
    this.getDataAnalytic('shipping_earning', 'this_month')
    this.getDataAnalytic('user_subscription', 'all_time')
    this.getExternalRevenue('/user/api/v1/admin/payment/revenue', 'dataPaymentServiceRevenue', 'this_month')
    this.getExternalRevenue('/user/api/v1/admin/qrisly/revenue', 'dataQrislyRevenue', 'this_month')
    this.analytics.forEach(item => this.getDataAnalytic(item.value, 'this_month'))
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    isClickOutside(event, popoverId, buttonId, datePickId) {
      const popover = document.getElementById(popoverId)
      const button = document.getElementById(buttonId)
      const datePick = document.getElementById(datePickId)
      return popover && !popover.contains(event.target)
        && button && !button.contains(event.target)
        && (!datePick || !datePick.contains(event.target))
    },
    handleClickOutside(event) {
      if (this.isClickOutside(event, 'periode-list', 'periodeRevenue', 'date-pick')) {
        this.popoverShowRevenue = false
      }
      if (this.isClickOutside(event, 'periode-list-subs', 'periode', 'date-pick-subs')) {
        this.popoverShow = false
      }
    },
    getDataForValue(value) {
      return this[DATA_MAP[value]] || {}
    },
    getLoadForValue(value) {
      return this[LOADING_MAP[value]] || false
    },
    buildFilterParams(filter, startdate, enddate, useDateRange) {
      if (filter !== 'custom') return { filter_type: filter }
      return {
        filter_type: filter,
        start_date: moment(useDateRange ? this.dateRange.startDate : startdate).format('YYYY-MM-DD'),
        end_date: moment(useDateRange ? this.dateRange.endDate : enddate).format('YYYY-MM-DD'),
      }
    },
    getLabelForFilter(filter) {
      return filter === 'custom'
        ? 'Custom Range'
        : this.optionsDate.find(item => item.value === filter)?.text || 'Unknown'
    },
    onRevenueFilterSelect(filter) {
      this.getDataAnalytic('revenue', filter)
      this.getDataAnalytic('subscription_revenue', filter)
      this.getDataAnalytic('shipping_earning', filter)
      this.getExternalRevenue('/user/api/v1/admin/payment/revenue', 'dataPaymentServiceRevenue', filter)
      this.getExternalRevenue('/user/api/v1/admin/qrisly/revenue', 'dataQrislyRevenue', filter)
      this.popoverShowRevenue = false
      if (filter === 'custom') this.lableButtonRevenue = 'Custom Range'
    },
    async getDataAnalytic(type, filter, startdate, enddate) {
      const useDateRange = DATE_RANGE_TYPES.includes(type)
      const params = this.buildFilterParams(filter, startdate, enddate, useDateRange)

      this[LOADING_MAP[type]] = true

      if (type === 'user_subscription') {
        this.lableButton = this.getLabelForFilter(filter)
      }

      if (REVENUE_TYPES.includes(type)) {
        this.lableButtonRevenue = this.getLabelForFilter(filter)
      }

      try {
        const { data } = await collaboratorAxiosIns.get(
          `/user/api/v1/admin/users/analytics/${type}`,
          { params },
        )

        this[DATA_MAP[type]] = data.data
        this[LOADING_MAP[type]] = false
        this.popoverShow = false

        if (type === 'user_subscription') {
          this.chartOptions.series = [
            {
              name: 'Enterprise',
              data: [this.dataSubscription.user_enteprise || 0],
              color: '#F95031',
            },
            {
              name: 'Pro',
              data: [this.dataSubscription.user_pro || 0],
              color: '#FBBC05',
            },
          ]
          this.loadingSubscription = false
        }
      } catch {
        this[LOADING_MAP[type]] = false
        this.$toast_error({ message: 'Failed to fetch data' })
      }
    },
    async getExternalRevenue(url, dataKey, filter) {
      this.isLoadingRevenue = true
      const params = this.buildFilterParams(filter, null, null, true)
      try {
        const { data } = await collaboratorAxiosIns.get(url, { params })
        this[dataKey] = data.data
        this.isLoadingRevenue = false
      } catch {
        this.isLoadingRevenue = false
        this.$toast_error({ message: 'Failed to fetch data' })
      }
    },
  },
}
</script>

<style scoped>
.bg-revenue {
  background: url('https://storage.googleapis.com/komerce/rajaongkir/bg-revenue-oa.png') no-repeat right bottom, #DCF3EB;
  background-size: 550px;
}
.decreased {
    background-color: #E31A1A;
    color: white;
    width: fit-content;
}
.increased-revenue {
    background-color: #34A770;
    color: white;
    width: fit-content;
}
.decreased-second {
    background-color: #FCBEBE;
    color: #E31A1A;
    width: fit-content;
}
.increased-second {
    background-color: #BEFCDE;
    color: #34A770;
    width: fit-content;
}
</style>
